export const realtorData = {
  email: 'proversopropiedades@unne.cl',
  phone: '953608834'
  // email: 'contacto@accionpanal.com',
};
